class RevealOnScrollHeader extends HTMLElement {
  constructor() {
    super();
    this.headerContainer = null;
    this.previousScrollPosition = 0;
    this.headerHiddenAmount = 0;
    this.isUpdating = false;
  }

  connectedCallback() {
    this.initializeHeader();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  initializeHeader() {
    this.headerContainer = this.parentElement;
    if (!this.headerContainer) {
      return;
    }

    this.applyFixedHeaderStyles();
    this.addEventListeners();
    window.requestAnimationFrame(this.updateHeaderVisibility);
  }

  addEventListeners() {
    window.addEventListener('scroll', this.scrollHandler, { passive: true });
    window.addEventListener('resize', this.resizeHandler);
  }

  removeEventListeners() {
    window.removeEventListener('scroll', this.scrollHandler, { passive: true });
    window.removeEventListener('resize', this.resizeHandler);
  }

  scrollHandler = () => {
    if (!this.isUpdating) {
      window.requestAnimationFrame(this.updateHeaderVisibility);
      this.isUpdating = true;
    }
  };

  resizeHandler = () => {
    this.initializeHeader();
  };

  updateHeaderVisibility = () => {
    const activePopup = this.querySelector('.page-header-main-nav sl-popup[active]');
    const currentScrollPosition = Math.max(0, window.scrollY);
    const scrollDistance = this.calculateScrollDistance(currentScrollPosition);

    if (!activePopup) {
      this.updateHeaderHiddenAmount(scrollDistance);
      this.updateHeaderTransform();
    }
    this.updateHeaderAppearance(currentScrollPosition);

    this.previousScrollPosition = currentScrollPosition;
    this.isUpdating = false;
  };

  calculateScrollDistance(currentScrollPosition) {
    const previousScrollPositionCapped = Math.max(0, this.previousScrollPosition);
    return currentScrollPosition - previousScrollPositionCapped;
  }

  updateHeaderHiddenAmount(scrollDistance) {
    this.headerHiddenAmount = Math.max(
      0,
      Math.min(this.headerHiddenAmount + scrollDistance, this.getBoundingClientRect().height),
    );
  }

  updateHeaderTransform() {
    this.style.transform = `translate3d(0, -${this.headerHiddenAmount}px, 0)`;
  }

  updateHeaderAppearance(currentScrollPosition) {
    if (currentScrollPosition === 0) {
      this.setTopOfPageAppearance();
    } else if (this.headerHiddenAmount < this.getBoundingClientRect().height) {
      this.setPartiallyVisibleAppearance(currentScrollPosition);
    } else {
      this.setFullyHiddenAppearance();
    }
  }

  setTopOfPageAppearance() {
    this.classList.add('top-of-page');
    this.classList.remove('bg-present');
  }

  setPartiallyVisibleAppearance(currentScrollPosition) {
    if (currentScrollPosition > this.getBoundingClientRect().height) {
      this.classList.remove('top-of-page');
      this.classList.add('bg-present');
    }
  }

  setFullyHiddenAppearance() {
    this.classList.add('bg-present');
  }

  applyFixedHeaderStyles() {
    this.style.position = 'fixed';
    this.style.zIndex = '999';
    this.style.insetInline = '0';
    this.style.insetBlockStart = '0';

    this.headerContainer.style.paddingTop = `${this.getBoundingClientRect().height}px`;
  }
}

customElements.define('reveal-on-scroll-header', RevealOnScrollHeader);
